export default {
  BASE_URL: '/cbm/requirement',
  api: [
    {
      name: 'demandDict', // type docking: 对接类型， category: 所属类别  status: 状态
      desc: '数据字典通用接口', // hasAll 是否存在全部项 true.存在 false.不存在
      method: 'GET',
      path: '/dict'
    },
    {
      name: 'detail',
      desc: '需求单详情',
      method: 'GET',
      path: '/detail'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/business/common.js